var map = {
	"./avatar_default_1.svg": "7712",
	"./avatar_default_10.svg": "5068",
	"./avatar_default_2.svg": "85fe",
	"./avatar_default_3.svg": "255d",
	"./avatar_default_4.svg": "6c8e",
	"./avatar_default_5.svg": "a1bb",
	"./avatar_default_6.svg": "2711",
	"./avatar_default_7.svg": "1639",
	"./avatar_default_8.svg": "7519",
	"./avatar_default_9.svg": "1fed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5265";